<!--
  CONFIRMADO lendo o DOM real (tenant conectaplan, 24/08/2026): o overlay
  global de loading é a biblioteca `ngx-spinner`, não um componente próprio —
  `<ngx-spinner bdcolor="rgba(51,51,51,0.8)" size="medium" color="#fff"
  type="ball-scale-multiple">`, montado como irmão do `<router-outlet>` (ver
  app.component.html), fora do `<app-login>`.
-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple"></ngx-spinner>
